export default "__VITE_ASSET__4f7bc569__"